import React from 'react';
import { motion } from 'framer-motion';
import useT from '../../../i18n';

/**
 * Testimonial — the ONLY ink-inverted section. Sets editorial spread tempo
 * like a magazine two-page feature. Portrait on left, quote on right.
 */
export default function Testimonial() {
  const t = useT();
  const s = t.landingV2.testimonial;

  return (
    <section
      className="bg-ink text-paper py-section"
      data-testid="landing-testimonial"
    >
      <div className="max-w-editorial mx-auto px-6 md:px-10">
        <motion.div
          initial={{ opacity: 0, y: 12 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
          className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-14 items-center"
        >
          {/* Portrait */}
          <div className="md:col-span-5">
            <img
              src="/landing/testimonial_maria.webp"
              alt="Maria K. — Intensivsykepleier"
              className="w-full aspect-[4/5] object-cover"
              loading="lazy"
              decoding="async"
              data-testid="testimonial-portrait"
            />
          </div>

          {/* Quote block */}
          <div className="md:col-span-7">
            <span
              className="block font-display text-display-lg text-paper/40 leading-none -mb-4 select-none"
              aria-hidden
            >
              &ldquo;
            </span>
            <blockquote className="mt-2">
              <p
                className="font-display font-light text-display-md text-paper leading-tight"
                data-testid="testimonial-quote"
              >
                {s.quote}
              </p>
            </blockquote>
            <p className="mt-8 font-sans text-sm text-paper/60">
              {s.attribution}
            </p>
            <p className="mt-2 font-sans text-xs text-paper/40 uppercase tracking-widest">
              {s.meta}
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
